import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const reasons = ['Intentaste "hablarlo" en el momento de la pelea, cuando ambos tenían el cortisol por las nubes.', 'Esperaste que el otro "se diera cuenta" de lo que necesitabas sin dar instrucciones claras.', 'Dejaste que las cuentas y las deudas se sentaran a la mesa en cada cena y cada noche de dormir.', 'Creíste que la solución era "tener más plata", cuando el problema es cómo gestionan el estrés juntos.'];
export function WhyItDidntWorkSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full py-20 md:py-28 bg-[#FFFFFF]" data-id="element-219">
      <div className="max-w-3xl mx-auto px-6" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2D2D] mb-12 text-center" data-id="element-222">
            Por qué lo que intentaste no funcionó:
          </h2>

          <div className="space-y-4" data-id="element-223">
            {reasons.map((reason, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {
            opacity: 0,
            x: -20
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex gap-4 items-start bg-[#F0EDEB] p-6 rounded-xl border border-black/5 shadow-md" data-id="element-224">
                <XCircleIcon className="w-6 h-6 text-[#8B1A2B] flex-shrink-0 mt-1" data-id="element-225" />
                <p className="text-lg text-[#6B7280]" data-id="element-226">{reason}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}